// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICopayDto
 */
export interface ICopayDto {
    /**
     * 
     * @type {number}
     * @memberof ICopayDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ICopayDto
     */
    category_type?: ICopayDtoCategoryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ICopayDto
     */
    amount?: number;
}

/**
* @export
* @enum {string}
*/
export enum ICopayDtoCategoryTypeEnum {
    ADOPTION = 'ADOPTION',
    DENTAL = 'DENTAL',
    DEPENDENT_CARE = 'DEPENDENT_CARE',
    MEDICAL = 'MEDICAL',
    PARKING = 'PARKING',
    PREMIUM = 'PREMIUM',
    PHARMACY = 'PHARMACY',
    TRANSIT = 'TRANSIT',
    VISION = 'VISION',
    LIFE_STYLE = 'LIFE_STYLE',
    WELLNESS = 'WELLNESS',
    TRAVEL = 'TRAVEL',
    PLAN_SPECIFIC = 'PLAN_SPECIFIC'
}


/**
 * Check if a given object implements the ICopayDto interface.
 */
export function instanceOfICopayDto(value: object): value is ICopayDto {
    return true;
}

export function ICopayDtoFromJSON(json: any): ICopayDto {
    return ICopayDtoFromJSONTyped(json, false);
}

export function ICopayDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICopayDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'category_type': json['category_type'] == null ? undefined : json['category_type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
    };
}

export function ICopayDtoToJSON(json: any): ICopayDto {
    return ICopayDtoToJSONTyped(json, false);
}

export function ICopayDtoToJSONTyped(value?: ICopayDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'category_type': value['category_type'],
        'amount': value['amount'],
    };
}

